import { render, staticRenderFns } from "./UiShowDiscountForm.vue?vue&type=template&id=2f37fa40&lang=pug&"
import script from "./UiShowDiscountForm.vue?vue&type=script&lang=js&"
export * from "./UiShowDiscountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports